<template>
  <div
    class="content-wrapper"
    :class="{ 'single-line': props.singleLine }"
  >
    <template
      v-for="(node, index) in props.content"
      :key="index"
    >
      <p>
        <template v-for="n in node.content">
          <slot
            v-if="n.type === 'cloze'"
            :node="n"
            name="cloze"
          >
            <Cloze :node="n"></Cloze>
          </slot>

          <slot
            v-if="n.type === 'text'"
            :node="n"
            name="text"
          >
            <Text :node="n"></Text>
          </slot>
        </template>
      </p>
      <span v-if="node.content.length === 0">&nbsp;</span>
    </template>
  </div>
</template>
<script setup lang="ts">
import type { Content } from '@/types/core'
import Text from '@/components/card-render/Text.vue'
import Cloze from '@/components/CardPreview/render/Cloze.vue'

const props = defineProps<{
  content: Content
  singleLine?: boolean
}>()
</script>
<style scoped>
.content-wrapper {
  display: block;
  width: 100%;
}

.single-line {
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.single-line :deep(.text) {
  white-space: nowrap !important;
  display: inline;
}

.single-line :deep(span) {
  white-space: nowrap !important;
  display: inline;
}

.single-line :deep(*) {
  display: inline;
}
</style>
